import { User } from "../../../../../data-model/firebaseAuthModel";
import {
  HealthFacilityFeatureConfig,
  shouldShowWritebackQcNotesForAuthStatus,
} from "../../../../../data-model/healthFacility";
import { GeneralOrderDetails } from "../../../../../data-model/medicalPaOrdersModel";
import { ScreenNamesForBigQuery } from "../../../../../enums/eventsData";
import { EventsName } from "../../../../../enums/eventsName";
import { ModalId } from "../../../../../enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../../../utils/organizationHelper";
import { apiWorkerManager } from "../../../../../workerManagers/workerManager";

/**
 * Logs a "Trigger RPA" analytics event and opens the appropriate modal
 * (Comments Writeback Validation or Trigger RPA) based on a random rollout %.
 *
 * @param generalOrderDetails - Flattened order details from Postgres.
 * @param user - The authenticated user triggering the action.
 * @param payerName - Payer name for analytics context.
 * @param dispatch - Redux dispatch for opening modals.
 * @param notesQcVersion1Rollout - Rollout percentage for the QC validation flow.
 * @param authOnFileAuthStatus - Current `auth_on_file.auth_status` for allowlist checks.
 * @param featureConfig - Facility `feature_config` for `qc_notes_visible_auth_statuses`.
 * @returns void
 */
export const handleTriggerRpa = (
  generalOrderDetails: GeneralOrderDetails,
  user: User,
  payerName: string,
  dispatch: AppDispatch,
  notesQcVersion1Rollout: number,
  authOnFileAuthStatus?: string,
  featureConfig?: HealthFacilityFeatureConfig,
) => {
  const qcAllowedForStatus = shouldShowWritebackQcNotesForAuthStatus(
    featureConfig,
    authOnFileAuthStatus,
  );
  const randomNumber = Math.random() * 100;
  const shouldOpenCommentsWritebackValidationModal =
    qcAllowedForStatus && randomNumber < notesQcVersion1Rollout;
  apiWorkerManager.enqueueAndProcess({
    patient_id:
      generalOrderDetails?.demographics?.patient_id ??
      generalOrderDetails?.demographics?.patient_mrn ??
      "",
    order_id: generalOrderDetails?.order_id ?? "",
    org_id: getOrgIdForFetchExternalWorklist() || "",
    event_name: EventsName.TRIGGER_RPA_CLICKED,
    user_id: user?.id ?? "",
    user_email: user?.email ?? "",
    additional_data: {
      screen_name: ScreenNamesForBigQuery.BUSNIESS_OFFICE_SCREEN,
      payer_name: payerName,
    },
  });
  if (shouldOpenCommentsWritebackValidationModal) {
    dispatch(
      setOpenedModalId({
        id: ModalId.COMMENTS_WRITEBACK_VALIDATION_MODAL,
      }),
    );
  } else {
    dispatch(setOpenedModalId({ id: ModalId.TRIGGER_RPA_MODAL_NEW }));
  }
};
